import { linkFromItem } from '$lib/utils';

import type ListConfigI from '$interfaces/misc/list-config.interface';
import types from '$lib/item-type-props';

export default (data): ListConfigI => {
  const baseUrl = '/skins/passes';

  return {
    itemType: 'Passes',
    relationKey: 'pass',
    jumbo: {
      title: `All Passes`,
      text: `Browse a list of all Keys. Sort and filter the items to ensure you find what you're looking for!`,
      imagePosition: 'top-left',
      image: '/assets/jumbo-images/howl-sticker.png',
    },
    itemLink: linkFromItem,
    pagination: {
      current: data.page || 1,
      link: baseUrl,
    },
    card: types.pass,
    meilisearch: {
      type: 'pass',
    },
  };
};
